var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5122_35468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77265 16.0803L4.58356 10.5566L2.13629 11.9675C0.612649 12.8512 0.0890129 14.8003 0.972649 16.3275C1.85265 17.8512 3.80174 18.3748 5.32901 17.4948L7.77265 16.0803Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.471 6.39236C18.5401 6.50872 18.6601 6.57418 18.7874 6.57418C18.8492 6.57418 18.911 6.55963 18.9692 6.5269L21.9074 4.82872C22.082 4.7269 22.1401 4.50508 22.042 4.33054C21.9401 4.15599 21.7183 4.09781 21.5438 4.19599L18.6056 5.89417C18.431 5.99599 18.3692 6.21781 18.471 6.39236Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0822 8.85358L19.6931 9.00267C19.4931 9.00994 19.3367 9.18085 19.344 9.38085C19.3513 9.57722 19.5149 9.72994 19.7076 9.72994H19.7222L23.1113 9.58085C23.3113 9.57358 23.4676 9.40267 23.4604 9.20267C23.4531 8.99903 23.2858 8.84994 23.0822 8.85358Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3191 4.14154C16.3809 4.18154 16.4464 4.19972 16.5154 4.19972C16.6354 4.19972 16.7518 4.14154 16.8209 4.03245L18.6464 1.17063C18.7554 0.999718 18.7045 0.7779 18.5373 0.668809C18.3664 0.559718 18.1445 0.610627 18.0354 0.781536L16.21 3.64335C16.1009 3.81063 16.1518 4.03245 16.3191 4.14154Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64537 16.9922L5.68901 18.1231C5.42719 18.2722 5.15082 18.3849 4.86719 18.4722C5.21628 20.2104 6.10719 21.7958 7.41264 22.9958C7.89991 23.4431 8.61992 23.5158 9.19082 23.1849C9.20537 23.1776 9.21628 23.1704 9.23082 23.1631C10.0636 22.6831 10.2526 21.5558 9.60901 20.8431C8.63446 19.7558 7.95446 18.4286 7.64537 16.9922Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5123 9.66063C11.3269 7.60609 10.3669 5.577 9.81053 3.94427C9.49416 3.00972 9.32325 2.2679 9.30143 1.69336C8.55598 2.67518 8.17416 4.28972 7.66507 5.67881C7.06507 7.55881 6.23962 9.04972 5.15234 10.0788L8.47234 15.8315C9.90871 15.4025 11.6142 15.4352 13.5414 15.8534C15.0069 16.1043 16.6105 16.5879 17.836 16.4243C15.7014 15.1043 12.876 10.2861 12.5123 9.66063Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2758 0.89363C9.60308 1.28272 10.3413 3.87181 11.9485 7.08272C13.1085 6.53727 14.5122 6.95908 15.1631 8.08999C15.8176 9.2209 15.4794 10.65 14.4249 11.3809C16.4176 14.41 18.3122 16.3736 18.9885 15.9809C19.8104 15.5045 18.5304 11.7409 16.1231 7.57363C13.7158 3.40636 11.1013 0.417266 10.2758 0.89363Z",
    fill: "#1D4650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5122_35468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.6180a0be86b4d935501a04aeb086be75.svg";
export { ForwardRef as ReactComponent };